import React from 'react';
import './Service-Detail-Page-Preview.scss';
import { Carousel } from 'react-bootstrap';
import { ASSET_URL } from '../../../../env/Configurations';
import MailOutlinedIcon from '@mui/icons-material/MailOutlined';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';

const ServiceDetailPagePreview = (props) => {
  const { config } = props;

  return (
    <>
      {config && (
        <div className='service-detail mx-2 mb-3'>
          {config?.images?.length && (
            <div className='service-detail-image-container'>
              <Carousel controls={false}>
                {config?.images?.map((slide, key) => (
                  <Carousel.Item key={key} indicators variant='dark'>
                    {!slide?.isVideo && (
                      <div
                        className={`d-flex ${slide?.shadowOverlay ? 'shadowed-img' : ''}`}
                        key={key}
                        style={
                          slide.imgURL
                            ? {
                                backgroundImage: 'url(' + ASSET_URL + slide.imgURL + ')',
                                backgroundSize: 'cover',
                                height: '200px',
                                objectFit: 'cover',
                                width: '100%',
                                backgroundRepeat: 'no-repeat',
                              }
                            : { backgroundRepeat: 'no-repeat', height: '200px' }
                        }
                      >
                        <div style={{ color: 'black', fontSize: '16px' }}>
                          {config?.isTitleActive && (
                            <p className='hero-banne-title mx-3 mt-3'>
                              {config?.titleH2 || 'H2 Title'}
                            </p>
                          )}
                        </div>
                      </div>
                    )}
                    {slide?.isVideo && (
                      <div className={`${slide?.shadowOverlay ? 'shadowed-img' : ''}`} key={key}>
                        <div className='video-container'>
                          {config?.isTitleActive && (
                            <div
                              className='title-label-h2'
                              style={{ color: 'black', fontSize: '16px' }}
                            >
                              {config?.titleH2 || 'H2 Title'}
                            </div>
                          )}
                          <video
                            style={{
                              width: '100%',
                              height: '200px',
                              objectFit: 'fill',
                              position: 'relative',
                              backgroundRepeat: 'no-repeat',
                              zIndex: 100,
                              top: 0,
                              left: 0,
                            }}
                            autoPlay
                            loop={slide?.loopPlayBack}
                            preload='auto'
                            src={slide?.videoURL}
                            muted
                          />
                        </div>
                      </div>
                    )}
                  </Carousel.Item>
                ))}
              </Carousel>
            </div>
          )}
          <div className='mx-2 my-2'>
            <p className='preview-breaks'>{config?.body || 'Body'}</p>
          </div>
          {config?.highLights?.isActive && (
            <div className='mt-2 mx-2'>
              {config?.highLights?.highLightList?.map((highLightKey, index) => (
                <div key={index}>{highLightKey.highLight}</div>
              ))}
            </div>
          )}
          <div className='my-2 mx-1 row d-flex py-1 align-items-center phone-email-row'>
            {(config?.phone?.isActive || config?.email?.isActive) && (
              <div className='col-md-8 d-flex'>
                {config?.phone?.isActive && (
                  <div className='col-md-6'>
                    <LocalPhoneOutlinedIcon className='phone-email-icon' /> <span>CALL</span>
                  </div>
                )}
                {config?.email?.isActive && (
                  <div className='col-md->)6'>
                    <MailOutlinedIcon className='phone-email-icon' /> EMAIL
                  </div>
                )}
              </div>
            )}
            {config?.cta?.isActive && (
              <div className='col-md-4 text-center py-1 cta-button'>
                {config?.cta?.title || 'CTA'}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default ServiceDetailPagePreview;
